<template>
  <div
    class="modal fade"
    id="modal-form-detViaje"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-geogo-top-left pt-2 pb-2">
          <h4 class="modal-title text-white">Detalle Viaje</h4>
          <button
            type="button"
            class="close text-white"
            @click="limpiarModal"
            data-dismiss="modal"
            aria-label="Close"
            id="close-modal"
            ref="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pt-1">
          <ul
            v-if="entidad_data"
            class="nav nav-tabs"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item">
              <a
                class="nav-link active"
                id="tab-InfoEntidad"
                @click="getDatosEntidad(entidad_id, type_entidad, 1)"
                data-toggle="tab"
                href="#InfoEntidad"
                >Información Entidad</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-PuntosGestion"
                @click="getDatosEntidad(entidad_id, type_entidad, 2)"
                data-toggle="tab"
                href="#PuntosGestion"
                v-if="type_entidad != 'Postulacion'"
                >Puntos Gestión</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-Inspecciones"
                @click="getDatosEntidad(entidad_id, type_entidad, 3)"
                data-toggle="tab"
                href="#Inspecciones"
                >Inspecciones</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-Mapa"
                @click="getDatosEntidad(entidad_id, type_entidad, 4)"
                data-toggle="tab"
                href="#Mapa"
                >Mapa</a
              >
            </li>
            <li
              class="nav-item"
              v-if="
                entidad_data &&
                  entidad_data.det_autorizacion &&
                  entidad_data.det_autorizacion.length
              "
            >
              <a
                class="nav-link"
                id="tab-autorizaciones"
                data-toggle="tab"
                href="#Autorizaciones"
                >Autorizaciones Formato 015</a
              >
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade active show" id="InfoEntidad">
              <GestionInfoHidrocarburos
                v-if="entidad_data && type_entidad"
                ref="gestionInfoHidrocarburos"
                :entidad_data="entidad_data"
                :type_entidad="type_entidad"
              />
            </div>
            <div class="tab-pane" id="PuntosGestion">
              <div class="card-body">
                <GestionInfoPuntosHidrocarburos
                  v-if="entidad_data && type_entidad"
                  ref="gestionInfoPuntosHidrocarburos"
                  :entidad_data="entidad_data"
                  :type_entidad="type_entidad"
                />
              </div>
            </div>
            <div class="tab-pane" id="Inspecciones">
              <div class="card-body">
                <GestionInfoInspeccionesHidrocarburos
                  v-if="entidad_data && type_entidad"
                  ref="gestionInfoInspeccionesHidrocarburos"
                  :entidad_data="entidad_data"
                  :type_entidad="type_entidad"
                />
              </div>
            </div>
            <div class="tab-pane" id="Mapa">
              <div class="card-body">
                <GestionMapaHidrocarburos
                  v-if="entidad_data && type_entidad"
                  ref="gestionMapaHidrocarburos"
                  :entidad_data="entidad_data"
                  :type_entidad="type_entidad"
                  @clickTramo="gestionMapaHidrocarburos.limpiarTramo()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import ViajeAutorizaciones from "./ViajeAutorizaciones";
import GestionInfoHidrocarburos from "./GestionInfoHidrocarburos";
import GestionMapaHidrocarburos from "./GestionMapaHidrocarburos";
import GestionInfoPuntosHidrocarburos from "./GestionInfoPuntosHidrocarburos";
import GestionInfoInspeccionesHidrocarburos from "./GestionInfoInspeccionesHidrocarburos";
export default {
  name: "GestionHidrocarburosDet",
  components: {
    GestionInfoHidrocarburos,
    GestionMapaHidrocarburos,
    GestionInfoPuntosHidrocarburos,
    GestionInfoInspeccionesHidrocarburos,
  },

  data() {
    return {
      accion: 1,
      viaje_id: null,
      entidad_data: null,
      entidad_id: null,
      tipo_entidad: null,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      det_puntos: {},
      det_inspecciones: {},
      det_enturnes: {},
      det_mapa: [],
      det_ruta: [],
    };
  },

  methods: {
    getDatosEntidad(entidad_id, tipo_entidad, accion) {
      this.accion = accion;
      this.entidad_id = entidad_id;
      this.type_entidad = tipo_entidad;
      axios
        .get("/api/admin/centralTrafico/detEntidad", {
          params: {
            type_entidad: tipo_entidad,
            entidad_id: entidad_id,
            accion: accion,
          },
        })
        .then((response) => {
          this.entidad_data = response.data;
        });
    },

    getDatosPuntos() {
      this.accion = 2;
      this.det_puntos = {};
      axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/ver_detalle_viaje",
          {
            params: {
              viaje_id: this.viaje_id,
              accion: this.accion,
            },
          }
        )
        .then((response) => {
          this.det_puntos = response.data;
        });
    },

    getDatosInspecciones() {
      this.accion = 3;
      this.det_inspecciones = {};
      axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/ver_detalle_viaje",
          {
            params: {
              viaje_id: this.viaje_id,
              det_postulacion_id: this.viaje.det_postulacion_id,
              accion: this.accion,
            },
          }
        )
        .then((response) => {
          this.det_inspecciones = response.data;
        });
    },

    limpiarModal() {
      this.entidad_data = null;
      this.entidad_id = null;
      this.type_entidad = null;
    },

    getDatosMapa() {
      this.accion = 5;
      this.det_mapa = [];
      this.det_ruta = [];
      axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/ver_detalle_viaje",
          {
            params: {
              viaje_id: this.viaje_id,
              accion: this.accion,
            },
          }
        )
        .then((response) => {
          this.det_mapa = response.data.posiciones;
          this.det_ruta = response.data.ruta;
        });
    },
  },
};
</script>
